import { useEffect, useState } from 'react'
import toast from 'react-hot-toast'
import { Input, Button } from '@oc-labs/wt-storybook'
import ModalV2 from '../../ModalV2'
import useModal from '../../../hooks/useModal'

const MODAL_NAME = 'translation-upsert-language'

export default function UpsertLanguageModal({ translationAdmin }) {
  const { close, data } = useModal(MODAL_NAME)
  const [isEditing, setIsEditing] = useState(false)
  const [language, setLanguage] = useState({
    projectId: '',
    code: '',
    name: '',
  })

  useEffect(() => {
    if (!data) {
      setLanguage({ projectId: '', code: '', name: '' })
      setIsEditing(false)
      return
    }

    const code = data?.code ?? ''
    const name = data?.name ?? ''
    const resolvedProjectId = data?.projectId ?? ''

    if (!resolvedProjectId) {
      toast.error('Please select a project first')
      close()
      return
    }

    setLanguage({ code, name, projectId: resolvedProjectId })
    setIsEditing(code !== '')
  }, [data])


  const handleConfirm = async () => {
    await translationAdmin.upsertLanguage(language)
    close()
    toast.success('Language added successfully')
  }

  return (
    <ModalV2
      name={MODAL_NAME}
      title={isEditing ? 'Edit Language' : 'Create Language'}
      className="w-full max-w-md"
    >
      <div className="space-y-6">
        <div className="space-y-4">
          <Input
            label="Code"
            disabled={isEditing}
            value={language.code}
            onChange={(e) => setLanguage({ ...language, code: e.target.value })}
            placeholder="Enter code (e.g. en)"
            type="text"
          />
          <Input
            label="Name"
            value={language.name}
            onChange={(e) => setLanguage({ ...language, name: e.target.value })}
            placeholder="Enter language name"
            type="text"
          />
        </div>

        <div className="flex gap-4 pt-2">
          <Button type="tertiary" onClick={close} className="w-1/2">
            Cancel
          </Button>

          <Button type="primary" onClick={handleConfirm} className="w-1/2">
            Confirm
          </Button>
        </div>
      </div>
    </ModalV2>
  )
}
